var _rect, _rect2, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressionActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 168.04,
    fill: "url(#pattern0_296_65)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 168.04,
    fill: "url(#pattern1_296_65)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_296_65",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 34,
    width: 100,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135 34H35V134H135V34Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_296_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.43 21.9648L89.6406 32.7754L99.9727 39.2891C81.5156 62.5312 54.8164 76.8477 32.2578 82.2969L38.6484 93.9375C63.9961 85.6758 90.832 70.7734 108.117 44.4453L115.988 49.4062L118.43 21.9648ZM119.934 44.7578L118.996 55.4609L108.977 49.1328C108.625 49.6602 108.254 50.168 107.883 50.6953V113.117H123.117V44.7578H119.934ZM90.5195 69.7578C88.0391 71.9062 85.4805 73.9375 82.8828 75.8516V113.117H98.1172V69.7578H90.5195ZM66.3594 86.1641C63.5469 87.6484 60.7344 89.0156 57.8828 90.3047V113.117H73.1172V86.1641H66.3594ZM32.8828 94.7578V113.117H48.1172V94.7578H47.0078C44.1133 95.832 41.2207 96.8281 38.3457 97.7461L36.9668 98.1758L35.0918 94.7578H32.8828Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_296_65",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_296_65",
    transform: "scale(0.00568182 0.00571429)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_296_65",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_296_65",
    transform: "scale(0.00568182 0.00571429)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_296_65",
    width: 176,
    height: 175,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAACvCAMAAABq6aQiAAAAAXNSR0IB2cksfwAAAMxQTFRFAAAA/////9Va/f39+vr6ysrK9vb2t7e3tLS0/v7+5+fn7+/vu7u709PT3t7e/Pz8wsLCsrKys7Oz8vLyv7+/2NjYxMTE4ODgtbW17e3turq60dHR/////////v7+/////////////f39/////v7+////5ubm/////f39////////////////////////////9/f3/v7+////////////3Nzc////z8/P6+vrwcHB4+Pj/////////////////////////////v7+////b9XQwgAAAER0Uk5TAP///////////////////////////////////zI7QTbj7jRGOPr/5j1D+PHq3T7Z/0ng89b/9f/////DSwRtni8Kc6M8Hnl0AAAD8klEQVR4nO3dW1MaQRAF4GFBAxpCwJjECKh4v+INNd4v//8/ubukUirbzQz0mR6r5jzuQO1X1LDFA3PaGOc8Pd+URHJzf+d+d/e0+zLcLOePHryHct5U3PbhTaRSw4tFvbm4DxW3T0W9SVLGiturwl6wuCfvzcWHIDHECxSDvLn4FCCGefNnxaq4uLcN8w7FPVnvCtILEIO94mK4Nxdvr4h5D+BeUbEXb5KUpMS0t1X9/eXPj58zy4u/tq7mZ4+PK5YhxQcC4o01K+/CbKXSKNsGKLbzLqXeRrlm/8OdFK9tBOmFiWFekBjohYg7+0AvI97vBOkVF8O9wuLOGdzLiM+cxV68jPjCUdy58OJlxHs7Lt6dPU9eIbFHr4jYyjsn5GXEm0eW3k2v3qnFR769nLgbpJcRN8aKVbxTiLs6XkZcY8XdhpKXEZcYsaKXE++S3pqidwJxl3yTF6+zWN3LiddHvbv6XidxEF4HcSBeTnzy1rseitdSHJDXShyU10IcmJcT3wbpHSPuheflxB3zEKCXEb+YPrGq6iVM6fVTQyxm3q963mJUdp0Aq3sLVTT4vfdYw1vEIsHv96+St8BFgVutILyjMALcbFVz76W2d0RWDG42sw38N/NuKXs/0gjw8AO+rA+ur7S9luD8A17OvCrPswnA2Q7ONrC61xKc74jFfEMoe63B6VducL20UGkoe+3A1eEW3kp3RFnZ6wCuD+bmPxH4+0z9WwRPkghGJ4LRiWB0IhidCEYngtGJYHQiGJ0IRieC0YlgdCIYnQhGJ4LRiWB0IhidCEYngtGJYHQiGB0bcBLBUySC0YlgdCLYq5f872Uw4I8wCpwEAh5xkeAkCPAoiwYnAYALVAw4UQcXoXIwVVuoDC40pdf75oVYTFTBxaR04cF0yGVFMOkt9Yy5JV+gBqa9+blFWqwEHuM15oR8kQp4rJcTB3HeZMQblNjKy50CDODMVOHp8UDE1t5AxA7eIMS0t7Bjgj49rn52lejEUBaTXrp1RFU8gZfrmNA74c730NCtI1odAuO6ieheF52WhvFdSipi2mvRVkV3E/lvGpm2Xct3l4ttf5lnMemVaIjz2Uck08Hnr/FJquXQV6eWXI+kn9YyVy/X1OmjF869WdSLWNTLtc2iuw3l+3yx7ZGTermGZ2Q/5+ReqJj0olq/UR2zuF51TIvvtF5uMgCiJ3l6L0RMe2WmL+CncfzzSsxe8CYW9HoRi3qhM4b+e+UmtHgQi3vBYoAXMjntjVd6jlMulp5NB/aKT/+De0FioHc4cfMzeQHiEmY2HUwM96bic0FxCTdf8b1YLnivMY+CYh9eY+7upaYJPz+53/0ViA0KDRH1ox4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressionActive);
export default __webpack_public_path__ + "static/media/progression-active.1f7880c13cfafb07e851fb86c7eae151.svg";
export { ForwardRef as ReactComponent };